import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';
import { IProps } from './index.d';


export const HalfScreenInfoModal = (props: IProps): JSX.Element => {
  const container = useRef(null);

  const { maskClosable = true } = props;
  const animationEnd = (event: any): void => {
    if(!event || event.animationName === 'moveDown') {
      props.onClose && props.onClose();
    }
  }

  const close = (event: any): void => {
    if(!event || event.target?.id) {
      const name = (container.current as any).className.replace('in-up', 'out-down');
      (container.current as any).className = name;
    }
  }

  const clickMask = (event: any) => {
    if(!maskClosable) {
      return;
    }
    close(event)
  }

  return ReactDOM.createPortal(
    <div
      id="containerModal"
      className="flex bg-modal"
      onClick={ clickMask }
    >
      <div
        className="move-in-up"
        styleName="modal-content"
        style={{ height: props.height }}
        ref={ container }
        onAnimationEnd={ animationEnd }
      >
        {props.title ? (
        <div className={ 'flex flex-center ' + (props.headerStyleName || '') } styleName="modal-header" >
          <span styleName="header-title">{ props.title }</span>
         { props.hideCloseBtn ? null: <button id="closeModal" className="text-minor">{ props.closeButtonText || '取消' }</button> }
        </div>):null}
          { props.children }
      </div>
    </div>,
    document.getElementById('modal') as HTMLDivElement
  )
}

export default HalfScreenInfoModal;
